const failingRegex = /^\b$/;

const minSpecialChars = 2;

function analyzeRegex(regex) {
  const res = {
    min: 0,
    max: 0,
    special: [],
    chars: [],
  };

  if (!regex) return res;

  // Fill in chars array with default alpha chars
  // Add lowercase letters a-z
  for (let i = 97; i <= 122; i += 1) res.chars.push(String.fromCharCode(i));
  // Add uppercase letters A-Z
  for (let i = 65; i <= 90; i += 1) res.chars.push(String.fromCharCode(i));
  // Add numbers 0-9
  for (let i = 48; i <= 57; i += 1) res.chars.push(String.fromCharCode(i));

  // Analyze regex
  const regexContent = regex.toString()
    .slice(3, -3)
    .replace('\\]', ']')
    .replace('\\/', '/');
  // console.log(`reg=${regexContent}`);

  const fields = regexContent.split('0-9a-zA-Z-]{');

  res.special = fields[0].split('');
  res.special.push('-');

  [res.min, res.max] = fields[1].split(',');

  // console.log(`res=${displayJson(res)}`);

  return res;
}

const analyzeText = (regexInfo = {}, text = '') => {
  const {
    min, max, special = [], chars = [],
  } = regexInfo;

  const specialCnt = text
    .split('')
    .filter((char) => (special.includes(char)));

  const forbidden = text
    .split('')
    .filter((char) => (!(special.includes(char) || chars.includes(char))));

  return ({
    forbidden,
    min: text.length < min,
    max: text.length > max,
    special: (specialCnt < minSpecialChars),
  });
};

function passwordEditCheck(regex, password, passwordConfirm) {
  const validatePassword = (text) => {
    const testRegex = regex?.password || failingRegex;

    return testRegex.test(text);
  };

  const regexInfo = analyzeRegex(regex?.password);

  const checks = analyzeText(regexInfo, password);

  const match = (password === passwordConfirm);

  const patternOk = validatePassword(password);

  return ({
    // Set if too short
    min: checks.min,
    // Set if too long
    max: checks.max,
    // Set if not enough special chars
    missingSpecial: checks.special,
    // List of forbidden chars
    forbidden: checks.forbidden,
    //
    minSpecialChars,
    // Set if password ok
    patternOk,
    // Set if passwords match
    match,
    // min char required
    minReq: regexInfo.min,
    maxReq: regexInfo.max,
  });
}

export default passwordEditCheck;
